"use client";

import { motion } from "framer-motion";

import { cn } from "lib/utils";

interface BlurIntProps {
  word: string;
  className?: string;
  variant?: {
    hidden: { filter: string; opacity: number };
    visible: { filter: string; opacity: number };
  };
  duration?: number;
  level: number;
}

const BlurIn = ({
  word,
  className,
  variant,
  duration = 1,
  level = 1,
}: BlurIntProps) => {
  const defaultVariants = {
    hidden: { filter: "blur(10px)", opacity: 0 },
    visible: { filter: "blur(0px)", opacity: 1 },
  };
  const combinedVariants = variant || defaultVariants;

  if (level === 1) {
    return (
      <motion.h1
        initial="hidden"
        animate="visible"
        transition={{ duration }}
        variants={combinedVariants}
        className={cn(
          "font-display text-center tracking-[-0.02em] drop-shadow-sm",
          className
        )}
      >
        {word}
      </motion.h1>
    );
  }

  return (
    <motion.h2
      initial="hidden"
      animate="visible"
      transition={{ duration }}
      variants={combinedVariants}
      className={cn(
        "font-display text-center tracking-[-0.02em] drop-shadow-sm",
        className
      )}
    >
      {word}
    </motion.h2>
  );
};

export default BlurIn;
